export const MediaReport = {
  // Download Media Report Form
  OPEN_DOWNLOAD_MEDIA_REPORT_MODAL: "OPEN_DOWNLOAD_MEDIA_REPORT_MODAL",
  CLOSE_DOWNLOAD_MEDIA_REPORT_MODAL: "CLOSE_DOWNLOAD_MEDIA_REPORT_MODAL",
};
